<span *ngIf="this.loaded && structure && structure['child']" fxFlex="row wrap">
    <mat-checkbox *ngIf="this.authService.checkUserIsDeveloping == 1" [(ngModel)]="this.genericService.devModeGeneric" (change)="this.genericService.devModeGenericFunction()">Dev</mat-checkbox>
    <mat-icon *ngIf="structure['close_dialog_out']" (click)="genericService.closeAdvicebar(index)" class="close-icon-advicebar">close</mat-icon>
    <app-generic style="width: 100%;" [structure]="structure"></app-generic>
</span>
<div *ngIf="!loaded" fxLayoutAlign="center center" fxFlex="100">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>